import { ConfirmDialog } from "@common/components/shared/confirm-dialog"
import { Button } from "@common/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@common/components/ui/dropdown-menu"
import { MoreHorizontal } from "lucide-react"
import ArchiveOutline from "~icons/material-symbols/archive-outline"
import DeleteOutline from "~icons/material-symbols/delete-outline"
import UnarchiveOutline from "~icons/material-symbols/unarchive-outline"

export function ListTableMenu({
  label,
  children,
}: {
  label: string
  children: React.ReactNode
}): React.ReactElement {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon-sm"
          className="shrink-0 text-muted-foreground"
          aria-label={`Actions for ${label}`}
        >
          <MoreHorizontal />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="flex flex-col">
        {children}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export function ArchiveMenuItem({
  archived,
  disabled,
  onSelect,
}: {
  archived: boolean
  disabled?: boolean
  onSelect: () => void
}): React.ReactElement {
  return (
    <DropdownMenuItem disabled={disabled} onSelect={onSelect}>
      {archived ? (
        <UnarchiveOutline className="size-4" />
      ) : (
        <ArchiveOutline className="size-4" />
      )}
      {archived ? "Restore" : "Archive"}
    </DropdownMenuItem>
  )
}

export function DeleteMenuItem({
  disabled,
  onSelect,
}: {
  disabled?: boolean
  onSelect: () => void
}): React.ReactElement {
  return (
    <DropdownMenuItem
      disabled={disabled}
      onSelect={onSelect}
      className="text-destructive focus:text-destructive"
    >
      <DeleteOutline className="size-4" />
      Delete
    </DropdownMenuItem>
  )
}

export function DeleteDialog({
  noun,
  pending,
  onConfirm,
  onCancel,
}: {
  noun: string
  pending: boolean
  onConfirm: () => void
  onCancel: () => void
}): React.ReactElement {
  return (
    <ConfirmDialog
      title={`Delete ${noun}?`}
      description={`This permanently deletes the ${noun}. It can't be restored.`}
      action="Delete"
      pendingAction="Deleting…"
      pending={pending}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  )
}
